import React, { useEffect } from "react";

export default function Toast({ toast, onClose }) {
  useEffect(() => {
    if (!toast) return;
    const t = window.setTimeout(() => onClose(), 4500);
    return () => window.clearTimeout(t);
  }, [toast, onClose]);

  if (!toast) return null;

  return (
    <div
      className={`toast toast--${toast.type || "info"}`}
      role="status"
      aria-live="polite"
    >
      <div className="toast__content">{toast.message}</div>
      <button
        className="toast__close"
        onClick={onClose}
        aria-label="Close message"
      >
        ×
      </button>
    </div>
  );
}
